import { render, staticRenderFns } from "./WhatsappContactCardActionMobile.vue?vue&type=template&id=64a5c748&scoped=true"
import script from "./WhatsappContactCardActionMobile.vue?vue&type=script&lang=js"
export * from "./WhatsappContactCardActionMobile.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContactCardActionMobile.vue?vue&type=style&index=0&id=64a5c748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5c748",
  null
  
)

export default component.exports